export default __webpack_public_path__ + "static/media/six_protocol_full.e930c604.png";